import {User} from "../types/user";
import {ThunkAction} from "redux-thunk";
import {RootState} from "../reducers/root-reducer";
import {ModalActions} from "./modal-action-types";

export const LOGGED_IN = `LOGGED_IN`
export const LOGGING_IN = 'LOGGING_IN'
export const LOGGED_OUT = 'LOGGED_OUT'
export const LOGIN_FAILED = 'LOGGIN_FAILED'

export const REFRESH_USER_DATA = 'REFRESH_USER_DATA'

export interface LoggenIdAction {
    type: typeof LOGGED_IN
    payload: User
}

export interface LoggedOutAction {
    type: typeof LOGGED_OUT
}

export interface LoggingInAction {
    type: typeof LOGGING_IN
}

export interface LoginFailedAction {
    type: typeof LOGIN_FAILED
}

export interface RefreshUserDataAction {
    type: typeof REFRESH_USER_DATA
    payload: User
}

export type SystemActions = LoggenIdAction | LoggedOutAction | LoggingInAction | RefreshUserDataAction | LoginFailedAction

export type SystemResult<R> = ThunkAction<R, RootState, undefined, SystemActions | ModalActions>
